import styled from 'styled-components';
import VehicleTypeFilter from './component';

import { selectStyles } from 'modules/filters/utils';

export default styled(VehicleTypeFilter)`
  ${selectStyles}
`;
